// extracted by mini-css-extract-plugin
export default {"registrationPage":"w_yAnlG3","loadingMessage":"erSY8EB9","errorMessage":"_FSYrLzn"};